export enum inlineEditMode {
	None,
	Some,
	All
}

export const inlineEditModeOptions = [
	{ id: inlineEditMode.None, title: inlineEditMode[inlineEditMode.None] },
	{ id: inlineEditMode.Some, title: "Selected columns only" },
	{ id: inlineEditMode.All, title: inlineEditMode[inlineEditMode.All] }
]

export const inlineEditModeHelpText = "Select which columns will be editable in the table.<br><b>None</b>- No columns will be editable.<br><b>Selected Columns</b>- Only columns marked as 'Allow Inline editing' in column options will be editable.<br><b>All</b>- All supported columns will be editable."
